import React from 'react';
export const SatelliteDish = () => (
  <svg width="161px" height="124px" viewBox="0 0 161 124" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-538.000000, -1672.000000)">
        <g transform="translate(539.000000, 1671.000000)">
          <path
            d="M99.168,118.8451 L146.07,118.8451"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.2876,118.8451 L6.4466,118.8451"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M41.4502,37.6137 L49.4802,37.6137"
            stroke="#E2E8EE"
            strokeLinecap="round"
          />
          <path
            d="M47.2178,34.891 L39.1878,34.891 C39.1878,34.891 37.5238,34.725 37.5238,33.591 C37.5238,32.457 38.2498,32.292 38.2498,32.292"
            stroke="#E2E8EE"
            strokeLinecap="round"
          />
          <path
            d="M107.2891,18.851 L115.3191,18.851"
            stroke="#E2E8EE"
            strokeLinecap="round"
          />
          <path
            d="M113.0567,16.1283 L105.0267,16.1283 C105.0267,16.1283 103.3627,15.9623 103.3627,14.8283 C103.3627,13.6943 104.0887,13.5293 104.0887,13.5293"
            stroke="#E2E8EE"
            strokeLinecap="round"
          />
          <path
            d="M82.1143,120.1381 C82.1143,122.4481 72.8083,124.3201 61.3283,124.3201 C49.8483,124.3201 40.5413,122.4481 40.5413,120.1381 C40.5413,117.8271 49.8483,115.9551 61.3283,115.9551 C72.8083,115.9551 82.1143,117.8271 82.1143,120.1381"
            fill="#D0D7DA"
          />
          <polygon
            fill="#FFFFFF"
            points="73.2144 114.6654 50.6534 114.6654 57.7734 95.1184 66.0944 95.1184"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="73.2144 114.6654 50.6534 114.6654 57.7734 95.1184 66.0944 95.1184"
          />
          <polygon
            fill="#FFFFFF"
            points="43.502 119.365 79.03 119.365 79.03 114.666 43.502 114.666"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="43.502 119.365 79.03 119.365 79.03 114.666 43.502 114.666"
          />
          <path
            d="M94.3189,92.3666 C85.2609,105.2846 69.0949,107.5086 56.1759,98.4516 C43.2569,89.3946 38.4789,72.4876 47.5359,59.5696 L94.3189,92.3666 Z"
            fill="#FFFFFF"
          />
          <path
            d="M71.7954,76.0268 L75.6194,70.6218"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M78.2339,70.9076 L78.9649,81.3926"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M74.479,68.2514 L64.646,71.2844"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="109.5298 45.5795 112.3278 44.7315 110.1538 48.7945 113.6538 47.7345"
          />
          <path
            d="M80.8902,67.1527 C81.1942,68.9237 80.0042,70.6047 78.2342,70.9077 C76.4632,71.2117 74.7822,70.0217 74.4792,68.2517 C74.1752,66.4807 75.3652,64.7987 77.1352,64.4967 C78.9062,64.1927 80.5872,65.3817 80.8902,67.1527"
            fill="#FFFFFF"
          />
          <path
            d="M80.8902,67.1527 C81.1942,68.9237 80.0042,70.6047 78.2342,70.9077 C76.4632,71.2117 74.7822,70.0217 74.4792,68.2517 C74.1752,66.4807 75.3652,64.7987 77.1352,64.4967 C78.9062,64.1927 80.5872,65.3817 80.8902,67.1527 Z"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="102.5962 54.8871 106.3212 53.7591 103.4262 59.1671 108.0852 57.7571"
          />
          <polyline
            stroke="#0B9CE5"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="92.7193 62.3471 97.7733 60.8171 93.8453 68.1561 100.1683 66.2421"
          />
          <path
            d="M59.835,97.9506 L90.472,92.6096 C90.472,92.6096 85.948,99.2506 79.03,100.9836 C68.592,103.5986 59.835,97.9506 59.835,97.9506"
            fill="#F3F4F6"
          />
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="113.3409 74.5121 132.5829 74.5121 132.5829 92.0121 143.1809 92.0121 143.1809 74.5121 145.9519 74.5121 145.9519 68.7591 148.8319 68.7591 148.8319 57.8301 153.1569 57.8301 153.1569 68.7591 156.6179 68.7591 156.6179 74.5121 159.1619 74.5121 159.1619 88.6051"
          />
          <path
            d="M57.7803,66.7514 L94.3193,92.3664 C85.2613,105.2844 69.0943,107.5084 56.1763,98.4514 C43.2573,89.3954 38.4783,72.4874 47.5363,59.5694 L52.1603,62.8124"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(0.000000, 0.710000)">
            <path
              d="M48.5923,11.6019 C46.2093,9.3059 43.0923,9.8199 43.0923,9.8199 C43.0923,9.8199 44.3763,4.1399 35.9433,1.5569 C27.5103,-1.0261 23.8443,4.4269 23.8443,4.4269 C19.2613,0.9829 15.7793,5.0009 14.1293,7.5839 C12.4793,10.1669 11.1963,12.7489 5.8793,13.3239 C0.5633,13.8979 0.0133,18.7769 0.0133,18.7769 L57.2223,18.7769"
              fill="#FFFFFF"
            />
            <path
              d="M48.5923,11.6019 C46.2093,9.3059 43.0923,9.8199 43.0923,9.8199 C43.0923,9.8199 44.3763,4.1399 35.9433,1.5569 C27.5103,-1.0261 23.8443,4.4269 23.8443,4.4269 C19.2613,0.9829 15.7793,5.0009 14.1293,7.5839 C12.4793,10.1669 11.1963,12.7489 5.8793,13.3239 C0.5633,13.8979 0.0133,18.7769 0.0133,18.7769 L57.2223,18.7769"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(59.000000, 18.710000)">
            <path
              d="M29.1778,6.85 C27.7868,5.51 25.9688,5.81 25.9688,5.81 C25.9688,5.81 26.7178,2.496 21.7978,0.99 C16.8778,-0.517 14.7388,2.664 14.7388,2.664 C12.0648,0.655 10.0328,2.999 9.0708,4.506 C8.1078,6.013 7.3588,7.52 4.2578,7.855 C1.1558,8.19 0.8348,11.037 0.8348,11.037 L34.2128,11.037"
              fill="#FFFFFF"
            />
            <path
              d="M29.1778,6.85 C27.7868,5.51 25.9688,5.81 25.9688,5.81 C25.9688,5.81 26.7178,2.496 21.7978,0.99 C16.8778,-0.517 14.7388,2.664 14.7388,2.664 C12.0648,0.655 10.0328,2.999 9.0708,4.506 C8.1078,6.013 7.3588,7.52 4.2578,7.855 C1.1558,8.19 0.8348,11.037 0.8348,11.037 L34.2128,11.037"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="32.0396 70.768 23.2886 70.768 23.2886 82.917 15.4126 82.917 15.4126 51.045 2.2866 51.045"
          />
          <path
            d="M47.2178,65.6742 L83.6338,90.3522"
            stroke="#E2E8EE"
            strokeLinecap="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
